import {config} from '../utils.js';
import {delegateListener} from '../utils/delegate-listener.js';
import {dataLayerEvent} from './data-layer.js';
import {EVENT_ADD_PAYMENT_INFO} from '../events/triggers/add-payment-info.js';
import {EVENT_ADD_TO_CART} from '../events/triggers/add-to-cart.js';
import {EVENT_BUYING_INTENTION} from '../events/triggers/buying-intention.js';
import {EVENT_FIRST_TIME_LISTER} from '../events/triggers/first-time-lister.js';
import {EVENT_LIKE} from '../events/triggers/like.js';
import {onLoad} from '../utils/onLoad.js';
import {EVENT_PRODUCT_VIEW} from '../events/triggers/product-view.js';
import {EVENT_PUBLISH} from '../events/triggers/publish.js';
import {EVENT_REGISTRATION} from '../events/triggers/registration.js';
import {EVENT_SEARCH} from '../events/triggers/search.js';
import {EVENT_SELLING_INTENTION} from '../events/triggers/selling-intention.js';
import {getUrlParam} from '../utils/url-helper.js';

onLoad(() => {
	dataLayerStatic();
    listenAddToCartEvent();
    listenAddPaymentInfoEvent();
	listenBuyingIntentionEvent();
	listenFirstTimeLister();
	listenLikeEvent();
	listenProductViewEvent();
	listenPublishEvent();
	listenRegistrationEvent();
	listenSearchEvent();
	listenSellingIntentionEvent();
	setCheckoutSessionIdHandler();
});

const dataLayerStatic = () => {
  let productId = config.product_id ?? config.product_id;
  productId ??= null;

  const userId = config.user ? config.user.id : null;
  const params = {
	  'content_type': config.content_type ?? '',
	  'content_category': config.content_category ?? '',
	  'content_id': productId,
	  'logged_in': !!config.user,
	  'user_id': userId,
    'dl_environment': config.environment,
	  'dl_domain': window.location.hostname,
  };
  window.dataLayer = window.dataLayer || [];
  dataLayer.push(Object.assign(params));
}

const listenAddPaymentInfoEvent = () =>
	document.addEventListener(EVENT_ADD_PAYMENT_INFO, async () => {
		const productJson = document.querySelector('.js-product-data');
		if (productJson) {
			const productData = JSON.parse(productJson.textContent);
			dataLayerEvent('add_payment_info', await productDataToEcommerce(productData));
		}
});

const listenAddToCartEvent = () => {
	document.addEventListener(EVENT_ADD_TO_CART, async e => {
		const productData = getProductData(e);
		if (!productData) {
			return;
		}

		let params = {};
		if (productData.primaryCategory && productData.secondaryCategory) {
			params = {
				primaryCategories: {
					content_type: productData.primaryCategory,
					content_category: productData.secondaryCategory,
				}
			}
		}
		dataLayerEvent('add_to_cart',
				Object.assign(params, await productDataToEcommerce(productData)));
  });
};


const listenFirstTimeLister = () =>
		document.addEventListener(EVENT_FIRST_TIME_LISTER, () =>
				dataLayerEvent('first_time_lister'));

const listenBuyingIntentionEvent = () =>
		document.addEventListener(EVENT_BUYING_INTENTION, () =>
				dataLayerEvent('buying_intention'));

const listenLikeEvent = () => {
	document.addEventListener(EVENT_LIKE, async e => {
		const productData = getProductData(e);
		if (!productData) {
			return;
		}

		dataLayerEvent('add_to_wishlist',	await productDataToEcommerce(productData));
	});
};

const listenProductViewEvent = () => {
	document.addEventListener(EVENT_PRODUCT_VIEW, async () => {
		const productJson = document.querySelector(
				'[data-id-product] > .js-product-data');
		if (productJson) {
			const productData = JSON.parse(productJson.textContent);
			dataLayerEvent('view_item', await productDataToEcommerce(productData));
		}
	});
};

const listenPublishEvent = () =>
		document.addEventListener(EVENT_PUBLISH, () =>
				dataLayerEvent('product_published'));

const listenRegistrationEvent = () => {
	document.addEventListener(EVENT_REGISTRATION, () => {
		dataLayerEvent('account_register', {
			method: getUrlParam('registration')
		});
	});
};

const listenSellingIntentionEvent = () =>
		document.addEventListener(EVENT_SELLING_INTENTION, () =>
				dataLayerEvent('selling_intention'));

const listenSearchEvent = () =>
		document.addEventListener(EVENT_SEARCH, () =>
				dataLayerEvent('search_result', config.currentSearchFilters));

const productDataToEcommerce = async (productData) => ({
	ecommerce: {
		currency: config.currency,
		value: productData.price,
		items: [{
			item_name: productData.name,
			item_id: productData.id,
			price: productData.price,
			item_brand: productData.brand, // marca
			item_category: productData.status, // estado
			item_category2: productData.color, // color
			quantity: 1
		}]
	}
});

const getProductData = (e) => {
	let productId;
	const productDetail = document.getElementById('product-sheet');
	if (productDetail) { //Ficha
		productId = productDetail.dataset?.idProduct;
	} else { //Parrilla
		const parent = e.target.activeElement.closest('[data-product-id]');
		productId = parent?.dataset?.productId;
	}

	if (!productId) {
		return null;
	}

	const productJson = document.getElementById(`json-product-${productId}`);

	if (!productJson) {
		return null;
	}

	return JSON.parse(productJson.textContent);
}


const setCheckoutSessionIdHandler = () => delegateListener('submit', '#payment-form', event => {
	if(!event.target.querySelector('input[name="ga_session"]')) {
		event.target.append(
			Object.assign(
				document.createElement('input'),
				{
					type: 'hidden',
					name: 'ga_session',
					value: JSON.stringify(
						window.dataLayer.reduce(
							(accumulator, element)=>
								element?.value?.event==='gtagApiGet' ? element.value.gtagApiResult : accumulator, {client_id: '0.0', session_id: '0'}
						)
					)
				}
			)
		);
	}
});

